((Drupal) => {
  "use strict";

  // Toggles row and grid view on SnapSnap page for mobile view.
  const toggleOlexaiCardsView = (context) => {
    const rowsBtn = context.querySelector(".rows-btn");
    const gridBtn = context.querySelector(".grid-btn");
    const cardWrapper = context.querySelector(".snap-snap-cards");

    if (!rowsBtn || !gridBtn || !cardWrapper) return;

    rowsBtn.addEventListener("click", () => {
      cardWrapper.classList.remove("grid");
      cardWrapper.classList.add("rows");
    });

    gridBtn.addEventListener("click", () => {
      cardWrapper.classList.remove("rows");
      cardWrapper.classList.add("grid");
    });
  };

  Drupal.behaviors.toggleOlexaiCardsView = {
    attach(context) {
      toggleOlexaiCardsView(context);
    },
  };
})(Drupal);
